<template>
  <v-app>
    <v-main>
      <router-view></router-view>
    </v-main>
    <spinner :loading="loading" :message="message"/>
  </v-app>
</template>

<script>
import bus from './plugins/bus.js'
import Spinner from './components/utils/common/Spinner.vue'

export default {
  name: 'App',
  components: {
    Spinner
  },
  data () {
    return {
      loading: false,
      message: '로딩 중입니다. 기다려주세요'
    }
  },
  created () {
    bus.$on('start:spinner', this.startSpinner)
    bus.$on('end:spinner', this.endSpinner)
  },
  beforeDestroy () {
    bus.$off('start:spinner')
    bus.$off('end:spinner')
  },
  methods: {
    startSpinner (msg = this.message) {
      this.loading = true
      this.message = msg
    },
    endSpinner () {
      this.loading = false
    }
  }
}
</script>
<style>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@300;400;500;700&display=swap');
* {
  font-family: 'Noto Sans KR', sans-serif;
}
a {
  text-decoration: none;
  color: black;
  background-color: transparent;
}
h1 {
  font-size: 32px;
  font-weight: 600;
}
</style>
